import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { components as Core } from '../../../../core';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import { useIntegrationDetailsForm } from '../hooks/useIntegrationDetailsForm';
import { MODAL_WIDTH } from '../utils/constants';
import { IntegrationDetailsHeader } from './IntegrationDetailsHeader';
import { IntegrationStatus } from './IntegrationStatus';
import { IntegrationDetailsTabs } from './tabs/IntegrationDetailsTabs';
import { css, spacing, StyleSheet } from '../../../../../styles';

/**
 * Coordinates the focused sections inside the integration details modal.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {object} props.integration
 * @param {Function|null} props.onClose
 */
export const IntegrationDetailsContent = ({ companyId, integration, onClose = null }) => {
    const dispatch = useDispatch();
    const isUpdating = useSelector(state => selectors.isUpdatingIntegration(state, integration.id));
    const isSettingRelogin = useSelector(state => (
        selectors.isSettingReloginIntegration(state, integration.id)
    ));
    const {
        getUpdatePayload,
        hasChanges,
        onChangeProperty,
        updatedData
    } = useIntegrationDetailsForm(integration, companyId);
    const isSaving = isSettingRelogin || isUpdating;
    const onSaveFields = fieldNames => {
        dispatch(actions.updateIntegration(getUpdatePayload(fieldNames)));
    };

    return (
        <Core.Modal
            isVisible={true}
            onClose={onClose}
            title={<IntegrationDetailsHeader integrationId={integration.id} />}
            modalWidth={MODAL_WIDTH}
            className={css(styles.modal)}>
            <IntegrationStatus integration={integration} />
            <IntegrationDetailsTabs
                companyId={companyId}
                hasChanges={hasChanges}
                integration={integration}
                isSaving={isSaving}
                onChangeProperty={onChangeProperty}
                onClose={onClose}
                onSaveFields={onSaveFields}
                updatedData={updatedData}
            />
        </Core.Modal>
    );
};

const styles = StyleSheet.create({
    modal: {
        maxWidth: 'calc(100vw - 32px)',
        '& .ant-modal-header': {
            padding: spacing.s3
        },
        '& .ant-modal-title': {
            margin: '0 !important'
        },
        '& .ant-modal-body': {
            overflowY: 'auto',
            paddingTop: spacing.s4,
            paddingBottom: spacing.s4
        },
        '@media (max-width: 540px)': {
            '& .ant-modal-header': {
                padding: spacing.s2
            },
            '& .ant-modal-body': {
                maxHeight: 'calc(100vh - 205px)',
                paddingLeft: spacing.s3,
                paddingRight: spacing.s3
            }
        }
    }
});
